




























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import InputPageWrapper from '@/views/components/input/InputPageWrapper.vue';

import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';
import { UnitSystem } from '@/interfaces/units';
import { AsphaltDesignMetric, IAsphaltDesignImperial } from '@/modules/design/interfaces/newAsphalt';
import GenericPavementDiagram from '@/modules/design/views/components/GenericPavementDiagram.vue';
import { designStore } from '@/store/store';
import { getAsphaltLayers } from '@/modules/design/lib/getLayers';
import { Route } from 'vue-router';
import { createAsphaltValidations } from '@/modules/design/lib/validations/asphalt';
import ValidatedInputPageWrapper from '@/views/components/input/ValidatedInputPageWrapper.vue';

Component.registerHooks([
  'beforeRouteLeave',

]);

@Component({
  components: {
    ValidatedInputPageWrapper,
    GenericPavementDiagram,
    PxNumberInput,
    InputPageWrapper,
  },
})
export default class NewAsphaltStructure extends Vue {
  @Prop() readonly pxDesignId!: string;

  @Prop() readonly page!: number;

  get scenario(): IAsphaltDesignImperial | AsphaltDesignMetric {
    const n = designStore.currentAsphalt;
    console.log('refetching scenario, units:', n.displayUnits);
    return n;
  }

  get scenarioImperial() {
    return designStore.currentAsphaltImperial;
  }


  validations() {
    // @ts-ignore
    return createAsphaltValidations(this.scenarioImperial);
  }

  get unitSystemIsImperial(): boolean {
    return designStore.displayUnits === UnitSystem.Imperial;
  }

  get singleLiftThickness() {
    return this.scenario.minimumThickness;
  }

  get layers() {
    return getAsphaltLayers(designStore.currentAsphaltImperial, this.thicknessUnit);
  }


  warnings: string[] = [];

  sync() {
    designStore.setCurrentAsphaltScenario(this.scenario);
  }

  save() {
    this.sync();
    designStore.saveCurrentAsphaltScenario();
  }

  beforeRouteLeave(to: Route, from: Route, next: Function) {
    this.save();
    next();
  }

  fields = [
    {
      key: 'liftTitle',
      label: 'Layer',
    },
    {
      key: 'coefficient',
      label: 'Layer Coefficient',
    },
    {
      key: 'drainage',
      label: 'Drainage Coefficient',
    },
    {
      key: 'thickness',
    },
  ];

  get thicknessUnit() {
    if (designStore.displayUnits === UnitSystem.Imperial) {
      return 'in';
    }
    return 'cm';
  }

  setMultipleLifts(v: boolean) {
    this.scenario.multipleLifts = v;
    if (this.scenario.multipleLifts) {
      // @ts-ignore
      this.validations = this.$v.scenarioImperial.surfaceLayers;
    } else {
      // @ts-ignore
      this.validations = this.$v.scenarioImperial.singleLiftGroup;
    }
  }

  mounted() {
    this.setMultipleLifts(this.scenario.multipleLifts);
  }

// beforeRouteLeave(to: Route, from: Route, next: Function){
//   this.warnings = [];
//   this.$v.$touch();
//   console.log(to, from);
//
//   const currPage = Number(to.path.substring(from.path.lastIndexOf('/') + 1));
//   const nextPage = Number(to.path.substring(to.path.lastIndexOf('/') + 1));
//
//   if (this.$v.$anyError && currPage < nextPage){
//     this.warnings.push('Please correct httpErrors.')
//   }
//   console.log('ready for next:', this.$v.$anyError, getValidationMessages(this.$v));
// }
}
